<template>
  <div class="row">
    <div class="col-md-12">
      <table class="ts-w-full" v-if="gradingDefinitions.length > 0">
        <thead>
          <th class="tw-whitespace-no-wrap" style="width: 20%">
            <span class="badge bg-info rounded-pill">1</span>
            {{ gradingDefinitions[0]['definition_name_en'] }}
          </th>
          <th class="tw-whitespace-no-wrap" style="width: 20%">
            <span class="badge bg-info rounded-pill">2</span>
            {{ gradingDefinitions[1]['definition_name_en'] }}
          </th>
          <th class="tw-whitespace-no-wrap" style="width: 20%">
            <span class="badge bg-info rounded-pill">3</span>
            {{ gradingDefinitions[2]['definition_name_en'] }}
          </th>
          <th class="tw-whitespace-no-wrap" style="width: 20%">
            <span class="badge bg-info rounded-pill">4</span>
            {{ gradingDefinitions[3]['definition_name_en'] }}
          </th>
          <th class="tw-whitespace-no-wrap" style="width: 20%">
            <span class="badge bg-info rounded-pill">5</span>
            {{ gradingDefinitions[4]['definition_name_en'] }}
          </th>
        </thead>
        <tbody>
          <tr>
            <td>{{ gradingDefinitions[5]['description'] }}</td>
            <td>{{ gradingDefinitions[6]['description'] }}</td>
            <td>{{ gradingDefinitions[7]['description'] }}</td>
            <td>{{ gradingDefinitions[8]['description'] }}</td>
            <td>{{ gradingDefinitions[9]['description'] }}</td>
          </tr>
          <tr>
            <th>F</th>
            <th>D</th>
            <th>C</th>
            <th>B</th>
            <th>A</th>
          </tr>
          <tr>
            <th>0-59</th>
            <th>60-69</th>
            <th>70-79</th>
            <th>80-89</th>
            <th>90-100</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gradingDefinition',
  props: ['gradingDefinitions'],
  data () {
    return {
      model: {}
    }
  }
}
</script>

<style lang="css" scoped>
table {
  border: 1px solid #d8d8d8;
}
table th {
  text-align: center;
  background-color: #f7fafc;
  border-right: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  padding: 5px 0 5px 0;
}
table td {
  border-top: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  background-color: #ffffff;
  min-height: 50px;
  vertical-align: top;
  text-align: center;
  padding: 5px;
}
</style>
